import React from 'react';
import Row from 'components/UIKit/Flex/Row';
import Column from 'components/UIKit/Flex/Column';
import baseStyle from './style';
import DropdownButton from 'components/buttons/DropdownButton';
import { dropdown } from 'components/UIKit/decorators';
import { ExternalLink } from 'components/Links';
import {
  GDCDataPortalIcon,
  GDCAPIIcon,
  GDCDataTransferToolIcon,
  GDCDocsIcon,
  GDCPublicationsIcon,
  GDCSubmissionPortalIcon,
  GDCAppsMenuIcon,
  GDCWebsiteIcon
} from 'components/icons';
const GDCAppsDropdown = ({
  style, active, setActive, mouseDownHandler, mouseUpHandler
}) => (
  <Row style={{alignSelf: 'stretch'}}>
    <DropdownButton
      data-testid="button-header-gdc-apps"
      style={{
        paddingLeft: '1.5rem',
        paddingRight: '1rem',
        margin: 0,
        border: 'none',
        borderLeft: '1px solid #e5e5e5',
        ...style
      }}
      PrefixComponent={<GDCAppsMenuIcon style={{paddingRight: '5px'}}/>}
      onClick={() => setActive(true)}>
        GDC Apps
    </DropdownButton>

    {active && (
      <Row
        data-testid="menu-header-gdc-apps"
        className="mdl-shadow--2dp"
        id="gdc-apps-menu"
        style={{
          ...baseStyle.dropDown,
          textAlign: 'center',
          justifyContent: 'space-between',
        }}
        onMouseDown={mouseDownHandler}
        onMouseUp={mouseUpHandler}
        onClick={() => setActive(false)}
      >
      <Column>
        <Row style={baseStyle.dropDownItem}>
          <ExternalLink
            customDataTestID="button-header-data-portal"
            hasArrowIcon={false}
            href={`${__GDC_PORTAL__}?utm_source=submission&utm_medium=apps`}
            title="Data Portal"
            >
              <GDCDataPortalIcon
                alt="Data Portal"
                style={{width: `21px`}}
                />
              <p>Data Portal</p>
          </ExternalLink>
        </Row>
        <Row style={baseStyle.dropDownItem}>
          <ExternalLink
            customDataTestID="button-header-api"
            hasArrowIcon={false}
            href={`${__GDC_WEBSITE__}/developers/gdc-application-programming-interface-api?utm_source=submission&utm_medium=apps`}
            title="GDC Application Programming Interface"
            >
            <GDCAPIIcon />
            <p>API</p>
          </ExternalLink>
        </Row>
        <Row style={baseStyle.dropDownItem}>
          <ExternalLink
            customDataTestID="button-header-documentation"
            hasArrowIcon={false}
            href={`${__GDC_DOCS__}?utm_source=submission&utm_medium=apps`}
            title="GDC Docs"
            >
            <GDCDocsIcon />
            <p>Documentation</p>
          </ExternalLink>
        </Row>
        <Row style={baseStyle.dropDownItem}>
          <ExternalLink
            customDataTestID="button-header-publication"
            hasArrowIcon={false}
            href="https://gdc.cancer.gov/about-data/publications?utm_source=submission&utm_medium=apps"
            title="GDC Publications"
            >
            <GDCPublicationsIcon />
            <p>Publications</p>
          </ExternalLink>
        </Row>
      </Column>
      <Column>
        <Row style={baseStyle.dropDownItem}>
          <ExternalLink
            customDataTestID="button-header-website"
            hasArrowIcon={false}
            href={`${__GDC_WEBSITE__}?utm_source=submission&utm_medium=apps`}
            title="GDC Website"
            >
            <GDCWebsiteIcon
              alt="GDC Website"
              style={{width: `21px`}}
              />
            <p>Website</p>
          </ExternalLink>
        </Row>
        <Row style={baseStyle.dropDownItem}>
          <ExternalLink
            customDataTestID="button-header-data-transfer-tool"
            hasArrowIcon={false}
            href="https://gdc.cancer.gov/access-data/gdc-data-transfer-tool?utm_source=submission&utm_medium=apps"
            title="GDC Data Transfer Tool"
            >
            <GDCDataTransferToolIcon />
            <p>Data Transfer Tool</p>
          </ExternalLink>
        </Row>
        <Row style={baseStyle.dropDownItem}>
          <ExternalLink
            customDataTestID="button-header-data-submission-portal"
            style={{backgroundColor: '#ccc'}}
            hasArrowIcon={false}
            href={`${__GDC_SUBUI__}?utm_source=submission&utm_medium=apps`}
            title="GDC Submission Portal"
            >
            <GDCSubmissionPortalIcon />
            <p>Data Submission Portal</p>
          </ExternalLink>
        </Row>
      </Column>
    </Row>)}
  </Row>
);

export default dropdown(GDCAppsDropdown);
